import React, { useState, useContext } from 'react';
import Header from '../Common/Header';
import Sidebar from '../Common/Sidebar';
import Footer from '../Common/Footer';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GMCContext } from '../../GMCContext';
import axios from 'axios';


export default function ManualOperation() {
    const { setIsSidebarEnabled } = useContext(GMCContext);

    // States for Manage Deposit
    const [depositStatus, setDepositStatus] = useState(false); // Set to boolean (false for non-active)
    const [depositReason, setDepositReason] = useState('');
    const [depositFormSubmitted, setDepositFormSubmitted] = useState(false);

    // States for Manage Withdrawal
    const [withdrawalStatus, setWithdrawalStatus] = useState(false); // Set to boolean (false for non-active)
    const [withdrawalReason, setWithdrawalReason] = useState('');
    const [withdrawalFormSubmitted, setWithdrawalFormSubmitted] = useState(false);

    // States for Manage Transfer
    const [TransferStatus, setTransferStatus] = useState(false); // Set to boolean (false for non-active)
    const [TransferReason, setTransferReason] = useState('');
    const [TransferFormSubmitted, setTransferFormSubmitted] = useState(false);


    // Handlers for Manage Deposit
    const handleDepositStatusChange = (event) => {
        setDepositStatus(event.target.checked); // Set to true or false based on checkbox state
        setDepositFormSubmitted(false);
    };


    const handleDepositReasonChange = (event) => {
        setDepositReason(event.target.value);
    };


    const handleDepositSubmit = async (event) => {
        event.preventDefault();
        if (!depositStatus && !depositReason) {
            toast.error("Please Provide A Valid Reason For Non-Activation In Deposit.", { position: 'top-right' });
        } else {
            try {
                const response = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                    method: 'admin',
                    submethod: 'updatetstatus',
                    status: depositStatus, // Send true or false directly
                    msg: depositReason,
                    key: process.env.REACT_APP_KEY,
                });

                if (response.data.resCode === 400) {
                    toast.error("Failed To Update Deposit Status.", { position: 'top-right' });
                } else {
                    toast.success("Deposit Status Updated Successfully!", { position: 'top-right' });
                    setDepositFormSubmitted(true);
                }
            } catch (error) {
                console.error(error);
                toast.error("An Error Occurred While Updating Deposit Status.", { position: 'top-right' });
            }
        }
    };


    // Handlers for Manage Withdrawal
    const handleWithdrawalStatusChange = (event) => {
        setWithdrawalStatus(event.target.checked); // Set to true or false based on checkbox state
        setWithdrawalFormSubmitted(false);
    };


    const handleWithdrawalReasonChange = (event) => {
        setWithdrawalReason(event.target.value);
    };


    const handleWithdrawalSubmit = async (event) => {
        event.preventDefault();
        if (!withdrawalStatus && !withdrawalReason) {
            toast.error("Please Provide A Valid Reason For Non-Activation In Withdrawal.", { position: 'top-right' });
        } else {
            try {
                const response = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                    method: 'admin',
                    submethod: 'updatew',
                    status: withdrawalStatus, // Send true or false directly
                    msg: withdrawalReason,
                    key: process.env.REACT_APP_KEY,
                });

                if (response.status === 200) {
                    toast.success("Withdrawal Status Updated Successfully!", { position: 'top-right' });
                } else {
                    toast.error("Failed To Update Withdrawal Status.", { position: 'top-right' });
                    setWithdrawalFormSubmitted(true);
                }
            } catch (error) {
                console.error(error);
                toast.error("An Error Occurred While Updating Withdrawal Status.", { position: 'top-right' });
            }
        }
    };


    // Handlers for Manage Withdrawal
    const handleTransferStatusChange = (event) => {
        setTransferStatus(event.target.checked); // Set to true or false based on checkbox state
        setTransferFormSubmitted(false);
    };
    const handleTransferReasonChange = (event) => {
        setTransferReason(event.target.value);
    };
    const handleTransferSubmit = async (event) => {
        event.preventDefault();
        if (!TransferStatus && !TransferReason) {
            toast.error("Please Provide A Valid Reason For Non-Activation In Transfer.", { position: 'top-right' });
        } else {
            try {
                const response = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                    method: 'admin',
                    submethod: 'updatetransf',
                    status: TransferStatus, // Send true or false directly
                    msg: TransferReason,
                    key: process.env.REACT_APP_KEY,
                });
                if (response.status === 200) {
                    toast.success("Transfer Status Updated Successfully!", { position: 'top-right' });
                } else {
                    toast.error("Failed To Update Transfer Status.", { position: 'top-right' });
                    setTransferFormSubmitted(true);
                }
            } catch (error) {
                console.error(error);
                toast.error("An Error Occurred While Updating Transfer Status.", { position: 'top-right' });
            }
        }
    };

    return (
        <>
            <Header />
            <Sidebar />
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid" onClick={() => setIsSidebarEnabled((prev) => !prev)}>
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item"><a href="javascript: void(0);">Tables</a></li>
                                        <li className="breadcrumb-item active">Manual Operation</li>
                                    </ol>
                                    <div className="page-title-right"></div>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center mt-5">
                            <div className="col-lg-10">
                                <h4 className="text-center mb-4" style={{ fontSize: '22px', fontWeight: 'bold' }}>Manual Operation</h4>
                                <div className="row g-4">
                                    {/* Manage Deposit */}
                                    <div className="col-md-6 col-lg-6">
                                        <div className="card shadow-sm border-0 rounded text-center p-4">
                                            <div className="card-body">
                                                <h5 className="card-title" style={{ fontSize: '18px', fontWeight: 'bold' }}>Manage Deposit</h5>
                                                <p className="card-text">Manage Deposit modifications.</p>
                                                <div className="mt-3">
                                                    <form className="was-validated" onSubmit={handleDepositSubmit}>
                                                        <div className="mb-2 text-center">
                                                            <label htmlFor="depositToggle" className="form-label mb-3" style={{ fontSize: '18px', fontWeight: 'bold', color: '#333' }}>
                                                                Status
                                                            </label>
                                                            <div className="toggle-container">
                                                                <input
                                                                    type="checkbox"
                                                                    className="custom-toggle"
                                                                    id="depositToggle"
                                                                    checked={depositStatus} // Will be true or false
                                                                    onChange={handleDepositStatusChange}
                                                                />
                                                                <label className="toggle-label" htmlFor="depositToggle">
                                                                    <span className="toggle-circle"></span>
                                                                </label>
                                                            </div>
                                                            <div style={{ marginTop: '10px', fontSize: '18px', fontWeight: 'bold', color: '#555' }}>
                                                                {depositStatus ? 'Activ' : 'Non Activ'}
                                                            </div>
                                                        </div>
                                                        {!depositStatus && (
                                                            <div className="mb-3">
                                                                <label htmlFor="depositReason" className="form-label" style={{ fontSize: '16px', fontWeight: 'bold', color: '#555' }}>
                                                                    Reason for Non-Activation
                                                                </label>
                                                                <textarea
                                                                    id="depositReason"
                                                                    className="form-control"
                                                                    value={depositReason}
                                                                    onChange={handleDepositReasonChange}
                                                                    required
                                                                    rows="2"
                                                                    placeholder="Enter reason here..."
                                                                    style={{
                                                                        borderRadius: '15px',
                                                                        border: '3px solid #ddd',
                                                                        backgroundColor: '#f9f9f9',
                                                                        color: 'GrayText',
                                                                        padding: '10px',
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                        <div className="mb-2 text-center">
                                                            <button
                                                                className="btn btn-primary btn-lg shadow-sm"
                                                                type="submit"
                                                                style={{
                                                                    backgroundColor: '#4caf50',
                                                                    border: 'none',
                                                                    padding: '10px 20px',
                                                                    fontSize: '16px',
                                                                    borderRadius: '25px',
                                                                    fontWeight: 'bold',
                                                                    boxShadow: '0 4px 6px rgba(8, 8, 8, 0.69)',
                                                                }}
                                                            >
                                                                Confirm Change
                                                            </button>
                                                        </div>
                                                    </form>
                                                    {depositFormSubmitted && (
                                                        <div className="alert alert-success text-center mt-3">
                                                            <strong>Success:</strong> Deposit Form Submitted Successfully!
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Manage Transfer */}
                                    <div className="col-md-6 col-lg-6">
                                        <div className="card shadow-sm border-0 rounded text-center p-4">
                                            <div className="card-body">
                                                <h5 className="card-title" style={{ fontSize: '18px', fontWeight: 'bold' }}>Manage Transfer</h5>
                                                <p className="card-text">Manage Transfer modifications.</p>
                                                <div className="mt-3">
                                                    <form className="was-validated" onSubmit={handleTransferSubmit}>
                                                        <div className="mb-2 text-center">
                                                            <label htmlFor="TransferToggle" className="form-label mb-3" style={{ fontSize: '18px', fontWeight: 'bold', color: '#333' }}>
                                                                Status
                                                            </label>
                                                            <div className="toggle-container">
                                                                <input
                                                                    type="checkbox"
                                                                    className="custom-toggle"
                                                                    id="TransferToggle"
                                                                    checked={TransferStatus} // Will be true or false
                                                                    onChange={handleTransferStatusChange}
                                                                />
                                                                <label className="toggle-label" htmlFor="TransferToggle">
                                                                    <span className="toggle-circle"></span>
                                                                </label>
                                                            </div>
                                                            <div style={{ marginTop: '10px', fontSize: '18px', fontWeight: 'bold', color: '#555' }}>
                                                                {TransferStatus ? 'Activ' : 'Non Activ'}
                                                            </div>
                                                        </div>
                                                        {!TransferStatus && (
                                                            <div className="mb-3">
                                                                <label htmlFor="TransferReason" className="form-label" style={{ fontSize: '16px', fontWeight: 'bold', color: '#555' }}>
                                                                    Reason for Non-Activation
                                                                </label>
                                                                <textarea
                                                                    id="TransferReason"
                                                                    className="form-control"
                                                                    value={TransferReason}
                                                                    onChange={handleTransferReasonChange}
                                                                    required
                                                                    rows="2"
                                                                    placeholder="Enter reason here..."
                                                                    style={{
                                                                        borderRadius: '15px',
                                                                        border: '3px solid #ddd',
                                                                        backgroundColor: '#F9F9F9',
                                                                        color: 'GrayText',
                                                                        padding: '10px',
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                        <div className="mb-2 text-center">
                                                            <button
                                                                className="btn btn-primary btn-lg shadow-sm"
                                                                type="submit"
                                                                style={{
                                                                    backgroundColor: '#4CAF50',
                                                                    border: 'none',
                                                                    padding: '10px 20px',
                                                                    fontSize: '16px',
                                                                    borderRadius: '25px',
                                                                    fontWeight: 'bold',
                                                                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                                                                }}
                                                            >
                                                                Confirm Change
                                                            </button>
                                                        </div>
                                                    </form>
                                                    {TransferFormSubmitted && (
                                                        <div className="alert alert-success text-center mt-3">
                                                            <strong>Success:</strong> Transfer Form Submitted Successfully!
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Manage Withdrawal */}
                                    <div className="col-md-6 col-lg-6">
                                        <div className="card shadow-sm border-0 rounded text-center p-4">
                                            <div className="card-body">
                                                <h5 className="card-title" style={{ fontSize: '18px', fontWeight: 'bold' }}>Manage Withdrawal</h5>
                                                <p className="card-text">Manage withdrawal modifications.</p>
                                                <div className="mt-3">
                                                    <form className="was-validated" onSubmit={handleWithdrawalSubmit}>
                                                        <div className="mb-2 text-center">
                                                            <label htmlFor="withdrawalToggle" className="form-label mb-3" style={{ fontSize: '18px', fontWeight: 'bold', color: '#333' }}>
                                                                Status
                                                            </label>
                                                            <div className="toggle-container">
                                                                <input
                                                                    type="checkbox"
                                                                    className="custom-toggle"
                                                                    id="withdrawalToggle"
                                                                    checked={withdrawalStatus} // Will be true or false
                                                                    onChange={handleWithdrawalStatusChange}
                                                                />
                                                                <label className="toggle-label" htmlFor="withdrawalToggle">
                                                                    <span className="toggle-circle"></span>
                                                                </label>
                                                            </div>
                                                            <div style={{ marginTop: '10px', fontSize: '18px', fontWeight: 'bold', color: '#555' }}>
                                                                {withdrawalStatus ? 'Activ' : 'Non Activ'}
                                                            </div>
                                                        </div>
                                                        {!withdrawalStatus && (
                                                            <div className="mb-3">
                                                                <label htmlFor="withdrawalReason" className="form-label" style={{ fontSize: '16px', fontWeight: 'bold', color: '#555' }}>
                                                                    Reason for Non-Activation
                                                                </label>
                                                                <textarea
                                                                    id="withdrawalReason"
                                                                    className="form-control"
                                                                    value={withdrawalReason}
                                                                    onChange={handleWithdrawalReasonChange}
                                                                    required
                                                                    rows="2"
                                                                    placeholder="Enter reason here..."
                                                                    style={{
                                                                        borderRadius: '15px',
                                                                        border: '3px solid #ddd',
                                                                        backgroundColor: '#f9f9f9',
                                                                        color: 'GrayText',
                                                                        padding: '10px',
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                        <div className="mb-2 text-center">
                                                            <button
                                                                className="btn btn-primary btn-lg shadow-sm"
                                                                type="submit"
                                                                style={{
                                                                    backgroundColor: '#4caf50',
                                                                    border: 'none',
                                                                    padding: '10px 20px',
                                                                    fontSize: '16px',
                                                                    borderRadius: '25px',
                                                                    fontWeight: 'bold',
                                                                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                                                                }}
                                                            >
                                                                Confirm Change
                                                            </button>
                                                        </div>
                                                    </form>
                                                    {withdrawalFormSubmitted && (
                                                        <div className="alert alert-success text-center mt-3">
                                                            <strong>Success:</strong> Withdrawal Form Submitted Successfully!
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
            <ToastContainer />
        </>
    );
}
